// This module handles print functionality

(function() {
  'use strict';

  window.PB_printPackage = function(state, config, printMode) {
    const allSelected = state.selections.flatMap(s =>
      (s.selectedProducts || []).map(p => ({
        ...p,
        className: p.product_type || s.productClassName,
        classId: s.productClassId
      }))
    );

    if (allSelected.length === 0) {
      alert('Please add products to your package before printing.');
      return;
    }

    // Use stored totals from page (set by updateCart) instead of recalculating
    // This ensures print uses the same values displayed on the page
    const { subtotal, discountAmount, bundleSavings, pmapSavings, afterBundleDiscountTotal, total, bundleDiscountPercent, discountEligibleProductIds } = window.PB_CURRENT_TOTALS;

    const formatCurrency = (amount) => {
      const truncated = Math.floor(amount * 100) / 100;
      return '$' + truncated.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    // printMode: 'customer' = dealer view (show margin/final prices), 'retail' = customer view (no margin)
    // If not logged in, printMode is ignored
    const showDealerPricing = printMode === 'customer' && window.PB_CUSTOMER_LOGGED_IN;

    // Build print HTML
    let printHTML = buildPrintHTML(allSelected, subtotal, discountAmount, bundleSavings, pmapSavings, afterBundleDiscountTotal, total, bundleDiscountPercent, discountEligibleProductIds, config, formatCurrency, showDealerPricing);

    // Create or get hidden iframe for printing
    let printFrame = document.getElementById('pbPrintFrame');
    if (!printFrame) {
      printFrame = document.createElement('iframe');
      printFrame.id = 'pbPrintFrame';
      printFrame.style.position = 'absolute';
      printFrame.style.width = '0';
      printFrame.style.height = '0';
      printFrame.style.border = 'none';
      document.body.appendChild(printFrame);
    }

    const frameDoc = printFrame.contentWindow || printFrame.contentDocument;
    if (frameDoc.document) frameDoc.document.write(printHTML);
    else frameDoc.write(printHTML);

    frameDoc.document.close();

    setTimeout(() => {
      printFrame.contentWindow.focus();
      printFrame.contentWindow.print();
    }, 300);
  };

  function buildPrintHTML(allSelected, subtotal, discountAmount, bundleSavings, pmapSavings, afterBundleDiscountTotal, total, bundleDiscountPercent, discountEligibleProductIds, config, formatCurrency, showDealerPricing) {
    const dateStr = new Date().toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" });

    let printHTML = `
<!DOCTYPE html>
<html>
<head>
  <title>ZLINE Package Summary - ${new Date().toLocaleDateString()}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Helvetica Neue', Arial, sans-serif; padding: 40px 60px; background: #ffffff; color: #333; }
    .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 40px; padding-bottom: 20px; border-bottom: 3px solid #c9a55a; }
    .header-info { text-align: right; }
    .header-info h1 { font-size: 24px; font-weight: 600; color: #1a1a1a; margin-bottom: 5px; }
    .header-info .date { font-size: 14px; color: #666; }
    .summary-box { background: #f9f9f9; border: 1px solid #e0e0e0; border-radius: 8px; padding: 20px; margin-bottom: 30px; display: flex; gap: 40px; }
    .summary-item { flex: 1; }
    .summary-label { font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 5px; }
    .summary-value { font-size: 18px; font-weight: 600; color: #1a1a1a; }
    table { width: 100%; border-collapse: collapse; margin-bottom: 30px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
    thead { background: #1a1a1a; color: white; }
    th { padding: 12px 8px; text-align: left; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.3px; }
    td { padding: 12px 8px; border-bottom: 1px solid #e0e0e0; font-size: 12px; }
    tbody tr:hover { background: #f9f9f9; }
    tbody tr:last-child td { border-bottom: none; }
    .product-title { font-weight: 500; color: #1a1a1a; }
    .sku { color: #666; font-family: 'Courier New', monospace; }
    .category { color: #666; }
    .price { font-weight: 600; color: #1a1a1a; }
    .discount { color: #16a34a; font-weight: 600; }
    .totals-section { background: #f9f9f9; border: 1px solid #e0e0e0; border-radius: 8px; padding: 25px; max-width: 400px; margin-left: auto; }
    .totals-row { display: flex; justify-content: space-between; padding: 10px 0; font-size: 15px; }
    .totals-row.subtotal { color: #666; }
    .totals-row.savings { color: #16a34a; font-weight: 500; }
    .totals-row.total { border-top: 2px solid #c9a55a; margin-top: 10px; padding-top: 15px; font-size: 20px; font-weight: 700; color: #1a1a1a; }
    .footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #e0e0e0; text-align: center; font-size: 12px; color: #999; }
     /* Prevent rows from splitting across pages */
    tr { page-break-inside: avoid; break-inside: avoid; }
    td { page-break-inside: avoid; break-inside: avoid; }
    thead { display: table-header-group; }
    tfoot { display: table-footer-group; }
    .totals-section { page-break-inside: avoid; break-inside: avoid; }
    .summary-box { page-break-inside: avoid; break-inside: avoid; }
    .header { page-break-inside: avoid; break-inside: avoid; }

    @media print {
      body { padding: 20px 30px; }
      table { box-shadow: none; }
      tr { page-break-inside: avoid !important; break-inside: avoid !important; }
      td { page-break-inside: avoid !important; break-inside: avoid !important; }
    }
  </style>
</head>
<body>
  <div class="header">
    <div style="flex: 1;">
      <h1 style="font-size: 28px; font-weight: 700; color: #1a1a1a; margin-bottom: 5px;">ZLINE KITCHEN & BATH</h1>
      <h2 style="font-size: 20px; font-weight: 400; color: #666; margin: 0;">Custom Package Summary</h2>
    </div>
    <div class="header-info">
      <div class="date">${dateStr}</div>
    </div>
  </div>

  <div class="summary-box">
    <div class="summary-item">
      <div class="summary-label">Total Items</div>
      <div class="summary-value">${allSelected.reduce((sum, p) => sum + (window.PB_getQuantity(p.id)), 0)} Products</div>
    </div>
    <div class="summary-item">
      <div class="summary-label">Bundle Discount</div>
      <div class="summary-value">${bundleDiscountPercent > 0 ? (bundleDiscountPercent * 100).toFixed(0) + '%' : 'None'}</div>
    </div>
    <div class="summary-item">
      <div class="summary-label">Total Savings</div>
      <div class="summary-value" style="color: #16a34a;">${formatCurrency(discountAmount)}</div>
      ${bundleSavings > 0 && pmapSavings > 0 ? `<div style="font-size: 11px; color: #666; margin-top: 3px;">${formatCurrency(bundleSavings)} bundle + ${formatCurrency(pmapSavings)} PMAP</div>` : ''}
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th style="width: 28%;">Description</th>
        <th style="width: 11%;">Category</th>
        <th style="text-align: center; width: 5%;">Qty</th>
        <th style="text-align: right; width: 11%;">MAP/PMAP</th>
        <th style="text-align: right; width: 12%;">Bundle Discount</th>
        <th style="text-align: right; width: 12%;">Price After Bundle Discount</th>
        ${showDealerPricing ? '<th style="text-align: right; width: 13%;">Your Original Price</th>' : ''}
        <th style="text-align: right; width: 13%;">Line Total</th>
      </tr>
    </thead>
    <tbody>
`;

    // Add product rows
    allSelected.forEach(product => {
      const rowHTML = buildProductRow(product, bundleDiscountPercent, discountEligibleProductIds, config, formatCurrency, showDealerPricing);
      printHTML += rowHTML;
    });

    printHTML += `
    </tbody>
  </table>

  <div class="totals-section">
    <div class="totals-row subtotal">
      <span>Subtotal (MAP):</span>
      <span>${formatCurrency(subtotal)}</span>
    </div>
    ${bundleSavings > 0 ? `
    <div class="totals-row savings">
      <span>Bundle Savings:</span>
      <span>-${formatCurrency(bundleSavings)}</span>
    </div>
    ` : ''}
    ${pmapSavings > 0 ? `
    <div class="totals-row savings">
      <span>PMAP Savings:</span>
      <span>-${formatCurrency(pmapSavings)}</span>
    </div>
    ` : ''}
    ${discountAmount > 0 ? `
    <div class="totals-row total">
      <span>After Discount:</span>
      <span>${formatCurrency(afterBundleDiscountTotal)}</span>
    </div>
    ` : ''}
    ${showDealerPricing ? `
    <div class="totals-row total" style="color: #16a34a;">
      <span>Final Price Total:</span>
      <span>${formatCurrency(total)}</span>
    </div>
    ` : ''}
  </div>

  <p style="font-size: 14px; font-weight: 600; color: #666; margin: 25px 0; text-align: center;">Package Builder quotes are estimates only. Pricing is subject to change based on current promotions.</p>

  <div class="footer">
    ZLINE Kitchen and Bath | Built to a Higher Standard | www.zlinekitchen.com
  </div>
</body>
</html>
`;

    return printHTML;
  }

  /**
   * Build product row for print table
   */
  function buildProductRow(product, bundleDiscountPercent, discountEligibleProductIds, config, formatCurrency, showDealerPricing) {
    const variant = product.variants[0];
    const sku = variant.sku || 'N/A';
    const hasPromoTag = product.tags?.some(tag => tag.toLowerCase() === 'promo');
    const hasPromo2Tag = product.tags?.some(tag => tag.toLowerCase() === 'promo 2');
    const isExcludedFromCategory = config.excludedFromDiscount.some(exc => product.className.includes(exc));
    const qty = window.PB_getQuantity(product.id);

    let mapPrice = null;
    let pmapPrice = null;
    let displayPrice = parseFloat(variant.price);
    let productMarginPercent = 0;

    if (window.PB_MAP_PRICES && window.PB_MAP_PRICES[product.id]) {
      const priceData = window.PB_MAP_PRICES[product.id];
      if (priceData.map) mapPrice = parseFloat(priceData.map);
      if (priceData.pmap) pmapPrice = parseFloat(priceData.pmap);
      if (priceData.marginPercent) productMarginPercent = parseFloat(priceData.marginPercent);
    }

    let productDiscount = 0;
    let priceAfterBundleDiscount;
    let finalPrice;
    let yourPrice;
    let mapPmapDisplay;
    let lineTotal;

    if (hasPromo2Tag) {
      const promo2Pricing = window.PB_getPromo2Pricing({
        pmapPrice,
        mapPrice,
        variantPrice: parseFloat(variant.price),
        marginPercent: productMarginPercent,
        bundleDiscountPercent: isExcludedFromCategory ? 0 : bundleDiscountPercent,
        isLoggedIn: window.PB_CUSTOMER_LOGGED_IN
      });

      displayPrice = promo2Pricing.displayPrice;
      productDiscount = isExcludedFromCategory ? 0 : promo2Pricing.productDiscount;
      priceAfterBundleDiscount = displayPrice;
      finalPrice = promo2Pricing.yourPrice;
      yourPrice = displayPrice;
      if (showDealerPricing && productMarginPercent > 0) {
        yourPrice = displayPrice * (1 - productMarginPercent / 100);
      }
      // Promo 2: all units at same price (no bundle discount)
      lineTotal = showDealerPricing ? finalPrice * qty : displayPrice * qty;
      mapPmapDisplay = `${promo2Pricing.priceLabel}: ${formatCurrency(displayPrice)}`;
    } else if (hasPromoTag) {
      const promoPricing = window.PB_getPromoPricing({
        pmapPrice,
        mapPrice,
        variantPrice: parseFloat(variant.price),
        marginPercent: productMarginPercent,
        bundleDiscountPercent: isExcludedFromCategory ? 0 : bundleDiscountPercent,
        isLoggedIn: window.PB_CUSTOMER_LOGGED_IN
      });

      displayPrice = promoPricing.displayPrice;
      productDiscount = promoPricing.productDiscount;
      priceAfterBundleDiscount = promoPricing.priceAfterDiscount;
      finalPrice = promoPricing.yourPrice;
      yourPrice = displayPrice;
      if (showDealerPricing && productMarginPercent > 0) {
        yourPrice = displayPrice * (1 - productMarginPercent / 100);
      }

      if (promoPricing.isAtSixPlusItems && qty > 1) {
        const extraPricing = window.PB_getPromoPricing({
          pmapPrice, mapPrice,
          variantPrice: parseFloat(variant.price),
          marginPercent: productMarginPercent,
          bundleDiscountPercent: 0,
          isLoggedIn: window.PB_CUSTOMER_LOGGED_IN
        });
        if (showDealerPricing) {
          lineTotal = finalPrice + extraPricing.yourPrice * (qty - 1);
        } else {
          lineTotal = priceAfterBundleDiscount + extraPricing.displayPrice * (qty - 1);
        }
      } else {
        lineTotal = showDealerPricing ? finalPrice * qty : priceAfterBundleDiscount * qty;
      }

      if (promoPricing.showStrikethroughPmap) {
        mapPmapDisplay = `<span style="text-decoration: line-through; color: #999; font-size: 0.85rem;">PMAP: ${formatCurrency(promoPricing.originalPmapPrice)}</span><br><span style="font-weight: 600;">MAP: ${formatCurrency(displayPrice)}</span>`;
      } else {
        mapPmapDisplay = `${promoPricing.priceLabel}: ${formatCurrency(displayPrice)}`;
      }
    } else {
      displayPrice = pmapPrice || mapPrice || displayPrice;

      if (discountEligibleProductIds.has(product.id) && bundleDiscountPercent > 0) {
        if (!isExcludedFromCategory) {
          productDiscount = parseFloat((displayPrice * bundleDiscountPercent).toFixed(2));
        }
      }

      priceAfterBundleDiscount = parseFloat((displayPrice - productDiscount).toFixed(2));

      yourPrice = displayPrice;
      if (showDealerPricing && productMarginPercent > 0) {
        yourPrice = displayPrice * (1 - productMarginPercent / 100);
      }

      if (showDealerPricing && productMarginPercent > 0) {
        finalPrice = priceAfterBundleDiscount * (1 - productMarginPercent / 100);
        const fullPriceUnit = displayPrice * (1 - productMarginPercent / 100);
        lineTotal = finalPrice + fullPriceUnit * (qty - 1);
      } else {
        finalPrice = priceAfterBundleDiscount;
        lineTotal = finalPrice + displayPrice * (qty - 1);
      }

      const priceLabel = pmapPrice ? 'PMAP' : (mapPrice ? 'MAP' : 'Price');
      mapPmapDisplay = `${priceLabel}: ${formatCurrency(displayPrice)}`;
    }

    const displayCategory = product.classId === 'under-counter-refrigeration' ? 'Under Counter Refrigeration' : product.className;
    const finishAccent = [product.selectedFinish, product.selectedAccent].filter(Boolean).join(' | ');
    const qtyNote = qty > 1 && productDiscount > 0 ? `<br><span style="font-size: 0.7rem; color: #666;">Discount on 1 unit</span>` : '';

    // Stock status badge (per SKU, based on Shopify variant availability)
    const isAvailable = variant.available !== false;
    const stockBadge = `<br><span style="font-size: 0.7rem; font-weight: 600; color: ${isAvailable ? '#16a34a' : '#dc2626'};">${isAvailable ? 'In Stock' : 'Out of Stock'}</span>`;

    const imageUrl = product.images && product.images[0] ? product.images[0].src : '';

    return `
      <tr>
        <td class="product-title" style="display: flex; align-items: center; gap: 10px;">
          ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" style="width: 60px; height: 60px; object-fit: contain; flex-shrink: 0;" />` : ''}
          <div>${product.title}<br><span class="sku">SKU: ${sku}</span>${stockBadge}${finishAccent ? `<br><span style="font-size: 0.75rem; color: #666;">${finishAccent}</span>` : ''}</div>
        </td>
        <td class="category">${displayCategory}</td>
        <td style="text-align: center;">${qty}</td>
        <td class="price" style="text-align: right;">${mapPmapDisplay}</td>
        <td class="discount" style="text-align: right; color: #dc2626;">${productDiscount > 0 ? '-' + formatCurrency(productDiscount) + qtyNote : '-'}</td>
        <td class="price" style="text-align: right;">${formatCurrency(priceAfterBundleDiscount)}</td>
        ${showDealerPricing ? `<td class="price" style="text-align: right;">${formatCurrency(yourPrice)}</td>` : ''}
        <td class="price" style="text-align: right; font-weight: 700; color: #16a34a;">${formatCurrency(lineTotal)}</td>
      </tr>
`;
  }

  console.log('Package Builder Print loaded');
})();
